export enum FundTypes {
  CASH = 'Cash',
  COMMITTED_CASH = 'Commited Cash',
  UNFUNDED = 'Unfunded',
  LONG_ACQUIRED = 'Long Acquired',
  LONG = 'Long',
  LONG_PUBLIC = '(Public)',
  LONG_PRIVATE = '(Private)',
  SHORT = 'Short',
  TOTAL = 'Total',
  AUM = 'AUM',
  NAV = 'NAV'
}
